import { Router } from "@angular/router";

export const toollist =  [
    {
        "Type": "Button",
        "Label": "Recommencer",
        "Color": "special",
        "Icon": "restart_alt",
        "Method": "remake",
        "Condition": "isAdmin"
    },
    {
        "Type": "Button",
        "Label": "Retour au questionnaire",
        "Color": "disabled",
        "Icon": "arrow_back_ios",
        "Method": "gotoQuestionnary"
    },
    {
        "Type": "Button",
        "Label": "Retour à l'établissement",
        "Color": "basic",
        "Icon": "location_city",
        "Method": "gotoBuildings"
    },
    {
        "Type": "Button",
        "Label": "Terminer",
        "Color": "primary",
        "Icon": "save",
        "Method": "savePdf"
    },
    {
        "Type": "Button",
        "Label": "Mode d'emploi",
        "Color": "danger",
        "Icon": "help",
        "Method": "toggleManual"
    },
]